module.exports = __webpack_public_path__ + "static/media/posts.63779538.svg";